<template>
  <q-page class="column no-wrap bg-white">
    <GameTracker class="col-grow" />
  </q-page>
</template>

<script setup lang="ts">
import GameTracker from 'components/GameTracker.vue'
</script>
